import React, { useState } from "react";
import { Helmet } from "react-helmet-async";

const shortcutData = [
  {
    title: "GitHub Terminal Kısayolları",
    category: "Terminal",
    shortcuts: [
      { command: "git init", description: "Yeni bir git deposu başlat" },
      { command: "git status", description: "Değişiklikleri kontrol et" },
      { command: "git add .", description: "Tüm değişiklikleri sahneye ekle" },
      { command: "git commit -m", description: "Değişiklikleri kaydet" },
      { command: "git push", description: "Değişiklikleri uzak depoya gönder" },
      { command: "git pull", description: "Uzak depodan değişiklikleri çek" },
      { command: "git checkout -b", description: "Yeni bir dal oluştur ve geç" },
      { command: "git merge", description: "Dalları birleştir" },
      { command: "git branch", description: "Dalları listele" },
      { command: "git clone", description: "Depoyu yerel makineye kopyala" },
    ],
  },
  {
    title: "Firebase Terminal Kısayolları",
    category: "Terminal",
    shortcuts: [
      { command: "firebase login", description: "Firebase'e giriş yap" },
      { command: "firebase init", description: "Firebase projesi başlat" },
      { command: "firebase deploy", description: "Canlıya aktar" },
      { command: "firebase serve", description: "Lokalde çalıştır" },
      { command: "firebase logout", description: "Firebase'den çıkış yap" },
      { command: "firebase use", description: "Aktif projeyi seç" },
      { command: "firebase functions:log", description: "Fonksiyon loglarını göster" },
      { command: "firebase emulators:start", description: "Emülatörleri başlat" },
      { command: "firebase hosting:channel:deploy", description: "Önizleme kanalı dağıt" },
      { command: "firebase database:get", description: "Veritabanı verilerini al" },
    ],
  },
  {
    title: "Node.js Terminal Kısayolları",
    category: "Terminal",
    shortcuts: [
      { command: "npm init", description: "Yeni bir Node projesi başlat" },
      { command: "npm install", description: "Bağımlılıkları yükle" },
      { command: "npm start", description: "Projeyi başlat" },
      { command: "npm run build", description: "Build al" },
      { command: "npm test", description: "Testleri çalıştır" },
      { command: "npm update", description: "Bağımlılıkları güncelle" },
      { command: "npm uninstall", description: "Bağımlılığı kaldır" },
      { command: "nodemon app.js", description: "Uygulamayı canlı izle" },
      { command: "npm cache clean", description: "Önbelleği temizle" },
      { command: "npm list", description: "Yüklü paketleri listele" },
    ],
  },
  {
    title: "Next.js Terminal Kısayolları",
    category: "Terminal",
    shortcuts: [
      { command: "npx create-next-app", description: "Yeni Next.js projesi oluştur" },
      { command: "npm run dev", description: "Geliştirme modunu başlat" },
      { command: "npm run build", description: "Prodüksiyon için build al" },
      { command: "npm start", description: "Prodüksiyon build'i çalıştır" },
      { command: "npm run lint", description: "Kod linting yap" },
      { command: "npm run export", description: "Statik siteyi dışa aktar" },
      { command: "npm run analyze", description: "Bundle analizini çalıştır" },
      { command: "npm run type-check", description: "TypeScript tür kontrolü yap" },
      { command: "npm run format", description: "Kodu biçimlendir" },
      { command: "npm run test", description: "Testleri çalıştır" },
    ],
  },
  {
    title: "Photoshop Klavye Kısayolları",
    category: "Adobe",
    shortcuts: [
      { command: "Ctrl + T", description: "Dönüştür (Transform)" },
      { command: "Ctrl + Z", description: "Geri al" },
      { command: "Ctrl + Shift + Z", description: "İleri al" },
      { command: "B", description: "Fırça aracını seç" },
      { command: "Ctrl + J", description: "Katmanı çoğalt" },
      { command: "Ctrl + D", description: "Seçimi kaldır" },
      { command: "Ctrl + E", description: "Katmanları birleştir" },
      { command: "V", description: "Taşıma aracını seç" },
      { command: "Ctrl + S", description: "Kaydet" },
      { command: "Ctrl + Alt + Shift + S", description: "Web için kaydet" },
    ],
  },
  {
    title: "Illustrator Klavye Kısayolları",
    category: "Adobe",
    shortcuts: [
      { command: "Ctrl + N", description: "Yeni belge oluştur" },
      { command: "V", description: "Seçim aracını seç" },
      { command: "P", description: "Kalem aracını seç" },
      { command: "Ctrl + G", description: "Nesneleri gruplandır" },
      { command: "Ctrl + Shift + G", description: "Gruplamayı çöz" },
      { command: "Ctrl + R", description: "Cetvelleri göster/gizle" },
      { command: "Ctrl + Y", description: "Önizleme moduna geç" },
      { command: "Ctrl + Shift + O", description: "Anahat moduna geç" },
      { command: "Ctrl + S", description: "Kaydet" },
      { command: "Ctrl + Shift + D", description: "Dönüşüm panelini göster" },
    ],
  },
  {
    title: "InDesign Klavye Kısayolları",
    category: "Adobe",
    shortcuts: [
      { command: "Ctrl + N", description: "Yeni belge oluştur" },
      { command: "T", description: "Metin aracını seç" },
      { command: "Ctrl + Y", description: "Hikaye düzenleyicisini aç" },
      { command: "Ctrl + D", description: "Dosya yerleştir" },
      { command: "Ctrl + G", description: "Nesneleri gruplandır" },
      { command: "Ctrl + Shift + G", description: "Gruplamayı çöz" },
      { command: "Ctrl + S", description: "Kaydet" },
      { command: "W", description: "Önizleme moduna geç" },
      { command: "Ctrl + Alt + Shift + Z", description: "Tüm geri alımları sıfırla" },
      { command: "Ctrl + Shift + L", description: "Metni sola hizala" },
    ],
  },
  {
    title: "Premiere Pro Klavye Kısayolları",
    category: "Adobe",
    shortcuts: [
      { command: "C", description: "Kesme aracını seç" },
      { command: "V", description: "Seçim aracını seç" },
      { command: "Ctrl + K", description: "Klip kes" },
      { command: "Ctrl + M", description: "Dışa aktar" },
      { command: "Ctrl + I", description: "Klip içe aktar" },
      { command: "Ctrl + Z", description: "Geri al" },
      { command: "Ctrl + Shift + Z", description: "İleri al" },
      { command: "Space", description: "Oynat/duraklat" },
      { command: "Ctrl + S", description: "Kaydet" },
      { command: "Ctrl + Shift + /", description: "Tüm panelleri varsayılana döndür" },
    ],
  },
  {
    title: "After Effects Klavye Kısayolları",
    category: "Adobe",
    shortcuts: [
      { command: "Ctrl + Alt + Shift + N", description: "Yeni proje oluştur" },
      { command: "Ctrl + I", description: "Dosya içe aktar" },
      { command: "Ctrl + Alt + /", description: "Kompozisyonu sıfırla" },
      { command: "Ctrl + K", description: "Kompozisyon ayarlarını aç" },
      { command: "U", description: "Tüm keyframe'leri göster" },
      { command: "Ctrl + Z", description: "Geri al" },
      { command: "Ctrl + S", description: "Kaydet" },
      { command: "Ctrl + Shift + D", description: "Katmanı böl" },
      { command: "Ctrl + D", description: "Katmanı çoğalt" },
      { command: "Space", description: "Oynat/duraklat" },
    ],
  },
  {
    title: "VS Code Kısayolları",
    category: "Editor",
    shortcuts: [
      { command: "Ctrl + P", description: "Dosya hızlı aç" },
      { command: "Ctrl + Shift + F", description: "Tüm projede ara" },
      { command: "Ctrl + `", description: "Terminali aç" },
      { command: "Alt + Shift + F", description: "Kodu biçimlendir" },
      { command: "Ctrl + B", description: "Yan paneli gizle/göster" },
      { command: "Ctrl + K, Ctrl + S", description: "Kısayol ayarlarını aç" },
      { command: "Ctrl + Shift + P", description: "Komut paletini aç" },
      { command: "Ctrl + Shift + N", description: "Yeni pencere aç" },
      { command: "Ctrl + W", description: "Sekmeyi kapat" },
      { command: "Ctrl + Shift + T", description: "Kapatılan sekmeyi geri aç" },
    ],
  },
  {
    title: "React CLI Kısayolları",
    category: "Terminal",
    shortcuts: [
      { command: "npx create-react-app my-app", description: "Yeni React projesi oluştur" },
      { command: "npm start", description: "Projeyi başlat" },
      { command: "npm run build", description: "Build al" },
      { command: "npm test", description: "Test çalıştır" },
      { command: "npm run eject", description: "Yapılandırmayı özelleştir" },
      { command: "npm install", description: "Bağımlılıkları yükle" },
      { command: "npm update", description: "Bağımlılıkları güncelle" },
      { command: "npm run lint", description: "Kod linting yap" },
      { command: "npm run format", description: "Kodu biçimlendir" },
      { command: "npm cache clean", description: "Önbelleği temizle" },
    ],
  },
  {
    title: "Linux Terminal Kısayolları",
    category: "Terminal",
    shortcuts: [
      { command: "ls", description: "Klasör içeriğini listele" },
      { command: "cd", description: "Dizin değiştir" },
      { command: "mkdir", description: "Yeni klasör oluştur" },
      { command: "rm -rf", description: "Dosya/klasör sil" },
      { command: "touch", description: "Yeni dosya oluştur" },
      { command: "cp", description: "Dosya/klasör kopyala" },
      { command: "mv", description: "Dosya/klasör taşı" },
      { command: "cat", description: "Dosya içeriğini göster" },
      { command: "chmod", description: "Dosya izinlerini değiştir" },
      { command: "sudo", description: "Komutu yönetici olarak çalıştır" },
    ],
  },
  {
    title: "MacOS Finder Kısayolları",
    category: "OS",
    shortcuts: [
      { command: "Cmd + Space", description: "Spotlight aramasını aç" },
      { command: "Cmd + Shift + G", description: "Klasöre git" },
      { command: "Cmd + Delete", description: "Dosyayı sil" },
      { command: "Cmd + C", description: "Kopyala" },
      { command: "Cmd + V", description: "Yapıştır" },
      { command: "Cmd + T", description: "Yeni sekme aç" },
      { command: "Cmd + N", description: "Yeni pencere aç" },
      { command: "Cmd + Shift + N", description: "Yeni klasör oluştur" },
      { command: "Cmd + I", description: "Bilgi panelini aç" },
      { command: "Cmd + Shift + .", description: "Gizli dosyaları göster/gizle" },
    ],
  },
  {
    title: "Chrome Geliştirici Araçları Kısayolları",
    category: "Browser",
    shortcuts: [
      { command: "Ctrl + Shift + I", description: "Geliştirici araçlarını aç" },
      { command: "Ctrl + Shift + C", description: "Element seçici aç" },
      { command: "Ctrl + R", description: "Sayfayı yenile" },
      { command: "F12", description: "Geliştirici konsolunu aç" },
      { command: "Ctrl + Shift + J", description: "Konsolu aç" },
      { command: "Ctrl + Shift + M", description: "Cihaz modunu aç" },
      { command: "Ctrl + ]", description: "Sonraki paneli seç" },
      { command: "Ctrl + [", description: "Önceki paneli seç" },
      { command: "Ctrl + Shift + D", description: "Dock konumunu değiştir" },
      { command: "Ctrl + Shift + P", description: "Komut menüsünü aç" },
    ],
  },
];

const ShortcutCard = ({ title, shortcuts }) => {
  const [copiedIndex, setCopiedIndex] = useState(null);

  const copyToClipboard = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 2000);
  };

  return (
    <div className="col-md-6 col-lg-4 mb-4">
      <div className="card h-100 shadow-sm">
        <div className="card-body">
          <h5 className="card-title">{title}</h5>
          <ul className="list-group list-group-flush">
            {shortcuts.map((s, index) => (
              <li
                key={index}
                className="list-group-item d-flex justify-content-between align-items-center"
              >
                <div>
                  <code className="bg-light p-1 rounded">{s.command}</code> — {s.description}
                </div>
                <button
                  onClick={() => copyToClipboard(s.command, index)}
                  className="btn btn-sm btn-outline-secondary"
                  title="Kopyala"
                >
                  {copiedIndex === index ? (
                    <span className="text-alert">Kopyalandı!</span>
                  ) : (
                    <i className="bi bi-copy"></i>
                  )}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

const Kisayollar = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [darkMode, setDarkMode] = useState(false);

  const categories = ["All", ...new Set(shortcutData.map((card) => card.category))];

  const filteredData = shortcutData.filter((card) => {
    const matchesCategory = selectedCategory === "All" || card.category === selectedCategory;
    const matchesSearch = card.shortcuts.some(
      (s) =>
        s.command.toLowerCase().includes(searchTerm.toLowerCase()) ||
        s.description.toLowerCase().includes(searchTerm.toLowerCase())
    ) || card.title.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    document.documentElement.classList.toggle("dark-mode");
  };

  // Structured data for SEO (JSON-LD)
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "Geliştiriciler ve Tasarımcılar İçin Kısayol Kartları",
    description:
      "GitHub, Firebase, Node.js, Next.js, Adobe ürünleri ve daha fazlası için terminal ve klavye kısayolları. Geliştiriciler ve tasarımcılar için hızlı referans.",
    url: "https://hacialikara.com/kisayollar",
    publisher: {
      "@type": "Organization",
      name: "Hacı Ali Kara",
      logo: {
        "@type": "ImageObject",
        url: "https://hacialikara.com/logo.png",
      },
    },
  };

  return (
    <>
      <Helmet>
        <title>Geliştiriciler ve Tasarımcılar İçin Kısayol Kartları</title>
        <link rel="canonical" href="https://hacialikara.com/kisayollar" />
        <meta
          name="description"
          content="GitHub, Firebase, Node.js, Next.js, Adobe ürünleri ve daha fazlası için terminal ve klavye kısayolları. Geliştiriciler ve tasarımcılar için hızlı referans."
        />
        <meta
          name="keywords"
          content="kısayollar, klavye kısayolları, terminal komutları, GitHub, Firebase, Node.js, Next.js, Photoshop, Illustrator, VS Code, React, Linux, SEO"
        />
        <meta name="author" content="Hacı Ali Kara" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://hacialikara.com/kisayollar" />
        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="Geliştiriciler ve Tasarımcılar İçin Kısayol Kartları"
        />
        <meta
          property="og:description"
          content="GitHub, Firebase, Node.js, Next.js, Adobe ürünleri ve daha fazlası için terminal ve klavye kısayolları. Geliştiriciler ve tasarımcılar için hızlı referans."
        />
        <meta property="og:url" content="https://hacialikara.com/kisayollar" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://hacialikara.com/og-image.jpg"
        />
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Geliştiriciler ve Tasarımcılar İçin Kısayol Kartları"
        />
        <meta
          name="twitter:description"
          content="GitHub, Firebase, Node.js, Next.js, Adobe ürünleri ve daha fazlası için terminal ve klavye kısayolları. Geliştiriciler ve tasarımcılar için hızlı referans."
        />
        <meta
          name="twitter:image"
          content="https://hacialikara.com/twitter-image.jpg"
        />
        {/* Structured Data */}
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      </Helmet>
      <div className={`container py-5 ${darkMode ? "bg-dark text-white" : ""}`}>
        <style>
          {`
            .dark-mode .card { background-color: #343a40; color: #ffffff; }
            .dark-mode .list-group-item { background-color: transparent; color: #ffffff; }
            .dark-mode .bg-light { background-color: #495057 !important; }
            .dark-mode .btn-outline-secondary { border-color: #6c757d; color: #ffffff; }
            .dark-mode .btn-outline-secondary:hover { background-color: #6c757d; }
            .card:hover { transform: translateY(-5px); transition: transform 0.3s; }
          `}
        </style>
        <div className="d-flex justify-content-between align-items-center mb-5">
          <h2 className="text-center">
            Geliştiriciler ve Tasarımcılar İçin Kısayol Kartları
          </h2>
          <button
            onClick={toggleDarkMode}
            className="btn btn-outline-secondary d-flex align-items-center"
          >
            {darkMode ? (
              <svg
                className="w-5 h-5 me-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                />
              </svg>
            ) : (
              <svg
                className="w-5 h-5 me-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                />
              </svg>
            )}
            {darkMode ? "Aydınlık Mod" : "Koyu Mod"}
          </button>
        </div>

        <div className="mb-5">
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Kısayol veya açıklama ara..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <div className="btn-group d-flex flex-wrap gap-2">
            {categories.map((category) => (
              <button
                key={category}
                className={`btn ${
                  selectedCategory === category ? "btn-primary" : "btn-outline-primary"
                }`}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        <div className="row">
          {filteredData.length > 0 ? (
            filteredData.map((card, index) => (
              <ShortcutCard key={index} title={card.title} shortcuts={card.shortcuts} />
            ))
          ) : (
            <div className="col-12 text-center">
              Sonuç bulunamadı.
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Kisayollar;